import { ChevronDown } from "lucide-react";

export default function Collapsible({ title, hint, defaultOpen = false, testid, children }) {
  return (
    <details open={defaultOpen} className="group rounded-2xl border border-slate-200 bg-white" data-testid={testid}>
      <summary className="flex items-center gap-3 cursor-pointer list-none px-5 py-4 select-none [&::-webkit-details-marker]:hidden">
        <span className="flex-1 font-display font-bold text-slate-900">{title}</span>
        {hint && <span className="text-xs text-slate-500">{hint}</span>}
        <ChevronDown className="w-4 h-4 text-slate-400 transition-transform group-open:rotate-180" />
      </summary>
      <div className="px-2 pb-2">{children}</div>
    </details>
  );
}
